import type {
  PersonalizationExpression,
  PersonalizationStage,
  PersonalizationValue,
} from '@/app/module/utils/pz-parser'

export type PzExpression = Pick<PersonalizationExpression, 'reference' | 'pipelineStages'> & { text: string }

type Labels = ReadonlyMap<string, { label: string }>

export const formatPzPipeline = (stages: PersonalizationStage[], labels: Labels): string[] =>
  stages.map((stage) => formatValue(stage.text, stage.content, labels))

const formatValue = (source: string, content: PersonalizationValue, labels: Labels): string => {
  let offset = 0
  return content
    .map((part) => {
      if (typeof part === 'string') {
        const start = offset
        // Parser text is unescaped; walk the source to retain literal argument spelling and whitespace.
        for (let index = 0; index < part.length; index += 1) {
          if (source[offset] === '\\' && /[\\{}]/.test(source[offset + 1] || '')) offset += 1
          offset += 1
        }
        return source.slice(start, offset)
      }
      offset += part.text.length
      const field = part.field.every((item) => typeof item === 'string') ? labels.get(part.field.join('')) : undefined
      if (!field) {
        return formatValue(
          part.text,
          ['{{', ...part.field, ...part.pipelineStages.flatMap((stage) => ['|', ...stage.content]), '}}'],
          labels,
        )
      }
      const pipeline = formatPzPipeline(part.pipelineStages, labels)
      return `{{${[field.label, ...pipeline].join(' | ')}}}`
    })
    .join('')
}
